module.exports = __webpack_public_path__ + "static/line2-fc6354a8bb8c3211ac786dc96426e243.png";